import './CartInvalidator.scss';

import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

const CartInvalidator = ({ title, text }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const modalNode = modalRef.current;
    if (!modalNode) return;

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ];
    const focusableElements = modalNode.querySelectorAll(focusableSelectors.join(','));

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    } else {
      modalNode.focus();
    }

    const handleKeyDown = (e) => {
      if (e.key !== 'Tab') return;

      const focusedIndex = Array.prototype.indexOf.call(focusableElements, document.activeElement);
      if (e.shiftKey) {
        if (focusedIndex === 0) {
          e.preventDefault();
          focusableElements[focusableElements.length - 1].focus();
        }
      } else {
        if (focusedIndex === focusableElements.length - 1) {
          e.preventDefault();
          focusableElements[0].focus();
        }
      }
    };

    modalNode.addEventListener('keydown', handleKeyDown);
    return () => {
      modalNode.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      className="CartInvalidator"
      role="dialog"
      aria-labelledby="cartInvalidatorTitle"
      aria-describedby="cartInvalidatorDesc"
      aria-modal="true"
      tabIndex={-1}
      ref={modalRef}
    >
      <div className="CartInvalidator__Content">
        <h2 className="CartInvalidator__Title" id="cartInvalidatorTitle">
          {title}
        </h2>
        <p
          className="CartInvalidator__Text"
          id="cartInvalidatorDesc"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <div className="CartInvalidator__Buttons">
          <button
            className="CartInvalidator__Button CartInvalidator__Button--White"
            data-response="false"
            onClick={() => window.history.back()}
          >
            Stanna
          </button>
          <a
            className="CartInvalidator__Button CartInvalidator__Button--Blue"
            href="?empty_cart=yes"
          >
            Fortsätt
          </a>
        </div>
      </div>
    </div>
  );
};

CartInvalidator.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CartInvalidator;
